import { FormElementType, FormFieldType } from '@wdx/shared/utils';

export const STRING_FIELD_TYPES = [
    FormFieldType.Text,
    FormFieldType.MultilineText,
    FormFieldType.UrlLookup,
    FormFieldType.TextDropdown,
    FormFieldType.PhoneNumber,
    FormFieldType.RichText,
];

export const NUMERIC_FIELD_TYPES = [
    FormFieldType.Integer,
    FormFieldType.Decimal,
];

export const CURRENCY_FIELD_TYPES = [FormFieldType.Currency];

export const ARRAY_FIELD_TYPES = [
    FormFieldType.Select,
    FormFieldType.Array,
    FormFieldType.Multiselect,
    FormFieldType.TagListMulti,
    FormFieldType.LookupMulti,
];

/**
 * I've removed FormFieldType.Array from this list as
 * it's not needed for setting up the validations. Going to treat
 * array as an number input type. Check ARRAY_VALIDATOR
 */
export const ARRAY_FIELD_TYPES_FOR_VALIDATORS = [
    FormElementType.Array,
    FormFieldType.Select,
    FormFieldType.Multiselect,
    FormFieldType.TagListMulti,
    FormFieldType.LookupMulti,
];

export const OPTIONS_FIELD_TYPES = [
    FormFieldType.TextDropdown,
    FormFieldType.Select,
    FormFieldType.Multiselect,
];

export const TAGS_FIELD_TYPES = [
    FormFieldType.TagListSingle,
    FormFieldType.TagListMulti,
];
